import React from "react";
import styled from "styled-components";
import Helmet from "react-helmet";
import { withRouter } from "react-router-dom";

import Page from "app/Page";
import { AnchorButton } from "@blueprintjs/core";
import CustomLink from "app/CustomLink";

const ButtonBox = styled.div`
  margin: 3em 0;
`;

const E404 = props => {
  const { location } = props;
  const title = "Page Not Found";
  return (
    <Page className="pt-ui-text-large pt-running-text">
      <Helmet title={title} />
      <h1>{title}</h1>
      <p>
        No page configured at path <code>{location.pathname}</code>.
      </p>
      <ButtonBox>
        <CustomLink as={AnchorButton} to="/" iconName="home">
          Go to homepage
        </CustomLink>
      </ButtonBox>
    </Page>
  );
};

export default withRouter(E404);



// WEBPACK FOOTER //
// ./src/app/NotFound.js